export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/drums.b9ad362.svg";